<template>
  <div class="screen-index">
      <div class="activity-wraper" :class="{'filter-blur':signModal||overModal||Modal}">
        <div class="activity-title">
          <div class="back" @click="goToLoading"><span>取消投屏</span></div>
          <div class="title">{{activityDetial.title}}<div class="vote-pic" v-if="activityDetial.picture"><span class="iconfont icon-sizhengtupian" @click="voteLargePic"></span></div></div>
          <div class="over" @click="overActivity" v-if="(activityType==1||activityType == 3||activityType == 5)&&activityDetial.complete!=1&&activityDetial.finish!=0&&activityDetial.status!=1">结束活动</div>
        </div>
        <router-view ref="votePic" @pushDetial="getDetial" :activitymoadal="signModal||overModal||Modal" @openVotePic="voteLargePic"></router-view>
        <div class="operation">
          <!-- <div class="stu-enter" @click="showSignModal">
            <span class="iconfont icon-huodongerweima activity-icon"></span> 
            <span class="text">活动二维码</span> 
          </div> -->
          <div class="sponsor-activity">
            <span class="iconfont icon-faqihuodong activity-icon"></span> 
            <span class="text">发起活动</span> 
            <ul class="activity-box">
              <!-- <li @click="showModal(4)"><img src="../../common/img/act_diss.svg" class="taolun"/> <span class="text">讨论</span></li> -->
              <li @click="showModal(3)"><img src="../../common/img/act_askandanswer@3x.svg" class="qiangda"/> <span class="text">抢答</span></li>            
              <!-- <li @click="showModal(5)"><img src="../../common/img/pick.png" class="xuanren"/> <span class="text">选人</span></li>             -->
              <li @click="showModal(2)"><img src="../../common/img/act_vote.svg" class="toupiao"/> <span class="text">投票</span></li>
              <li @click="showModal(1)"><img src="../../common/img/act_sign.svg" class="dianming"/> <span class="text">点名</span></li>
            </ul>
          </div>
        </div>
      </div>
     <modal :type="type" :modal="Modal" :modalTitle="modalTitle"  @closeModal="closeModal"></modal>
    <div class="sign-modal" v-show="signModal" @click="closeSignModal">
        <div class="modal-title">扫码参与活动</div>
        <div class="erweima">
            <canvas id="activity_canvas"></canvas>
            <div class="text">支持财道书院APP、微信扫码</div>
            <div class="close" @click="closeSignModal"><span class="iconfont icon-guanbi"></span></div>
        </div>
    </div>
    <!-- <div class="bg-img" v-if="signModal">
    </div> -->
    <div class="over-modal" v-if="overModal">
      <div class="over-wraper">
        <div class="over-title">
          提醒
        </div>
        <div class="text">
          {{overMsg}}
        </div>
        <div class="operation">
          <button class="sure" @click="overActivitySure">确定</button>
          <button class="cancel" @click="overActivityCancel">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode' 
import modal from '@/components/modal/modal/'
import EventHandler from '../../common/js/EventHandler'
export default {
  name: 'screenIndex',
  data () {
    return {
      type:0,
      Modal:false,
      activity:['点名','投票','抢答','讨论','选人'], 
      modalTitle:"" ,
      signModal:false,
      overMsg:'',
      overModal:false,
      activityDetial:[],
      activityType:1,
    }
  },
  methods:{
    showModal:function(type){
      this.type = type;
      this.Modal = true;
      this.modalTitle = this.common.getDate()+this.activity[this.type-1];
    },
    closeModal:function(){
      this.Modal = false;
    },
    goToLoading:function(){
      this.overActivityScreen()
    },
    showSignModal:function(){
      this.useqrcode()
    },
    //生成活动二维码
    useqrcode(){  
        var that = this;
        var a = that.type + 2;
        var c = that.common.getCookie('activityId');
        var d = that.common.getCookie('ocId');
        that.QueryDetail=that.pathURL+'/r/?a='+a+'&c='+c+'&d='+d;
        var canvas = document.getElementById('activity_canvas')
        QRCode.toCanvas(canvas, that.QueryDetail,{width:558,height:558}, function (error) {
        if (error) console.error(error)
        console.log('success!');
        that.signModal = true;
        })
    },
    closeSignModal:function(){
      this.signModal = false;
    },
    voteLargePic:function(){
      this.$refs.votePic.largePic()
    },
    overActivity:function(){
      if(this.$route.name=='responder'){
         var isNoScore=false;
         for(var i=0;this.activityDetial.students&&i<this.activityDetial.students.length;i++){
            if(this.activityDetial.students[i].score == 0){
              isNoScore=true;
              break;
            }
        }
        if(isNoScore){
          this.overMsg = '有学生未打分，结束后该学生将得0分,结束后将不能再修改，确定结束抢答？';
        }
      }
      this.overModal = true;
    },
    //结束点名
    overSign:function(){
      var that = this;
      var userId = Number(that.common.getCookie('userId'))
      var activityId = Number(that.common.getCookie('activityId'))
      that.$http.post(that.baseURL1+'/newAttendance/finishAttendance',{
        'attanceID':activityId,
        'classID':-1,
        'userID':userId
      }).then((res)=>{
          var data = res.data;
          that.overModal = false;
          console.log(data)
      })
    },
    //结束抢答
    overResponder:function(){
      var that = this;
      var userId = Number(that.common.getCookie('userId'))
      var activityId = Number(that.common.getCookie('activityId'))
      that.$http.post(that.baseURL1+'/interlocution/changeComplete',{
        'interlocutionId':activityId,
        'complete':1
      }).then((res)=>{
          var data = res.data;
          that.overModal = false;
          console.log(data)
      })
    },
    overPick () {
      let that = this
      var activityId = Number(that.common.getCookie('activityId'))
      that.$http.post(that.baseURL1+'/classquestion/endActivity?id='+activityId).then((res)=>{
        that.overModal = false;
        EventHandler.toggleEvent('overPick')
      })
    },
    //结束活动投屏
    overActivityScreen:function(){
      var that = this;
      var userId = that.common.getCookie('userId');
      var activityId = that.common.getCookie('activityId');
      that.$http.get(that.baseURL+'/appscreen/endActivity?type='+that.type+'&userId='+userId+'&activityId='+activityId+'&sender=pc').then((res)=>{
               that.$router.replace('/loadingIn')
      })
    },
    overActivitySure:function(){
      if(this.type ==1){
        this.overSign()
      }
      if(this.type == 3){
        this.overResponder()
      }
      if(this.type == 5){
        this.overPick()
      }
    },
    overActivityCancel:function(){
      this.overModal = false;
    },
    getDetial:function(data){
      this.activityDetial = data;      
    },
    votePicOperation:function(param){
      if(param == 1){
        this.voteLargePic()
      }
    }    
  },
  created:function(){
    var that = this;
  },
  mounted:function(){
     if(this.$route.name=='signIn'||this.$route.name=='signDetail'){
        this.type = 1;
        this.activityType = 1;
        this.overMsg = '确定结束签到？'
      }
      if(this.$route.name=='vote'){
        this.type = 2;
        this.activityType = 2;
        this.overMsg = '确定结束投票？'
      }
      if(this.$route.name=='responder'){
        this.type = 3;
        this.activityType = 3;
        this.overMsg = '确定结束抢答？'
      }
      if(this.$route.name=='discuss'){
        this.type = 4;
        this.activityType = 4;
        this.overMsg = '确定结束讨论？'
      }
      if(this.$route.name=='pick'){
        this.type = 5;
        this.activityType = 5;
        this.overMsg = '确定结束选人？'
      }
  },
  watch:{
    $route(to,from){
      if(this.$route.name=='signIn'){
        this.type = 1;
        this.activityType = 1;
        this.overMsg = '确定结束签到？'
      }
      if(this.$route.name=='vote'){
        this.type = 2;
        this.activityType = 2;
        this.overMsg = '确定结束投票？'
      }
      if(this.$route.name=='responder'){
        this.type = 3;
        this.activityType = 3;
        this.overMsg = '确定结束抢答？'
      }
      if(this.$route.name=='discuss'){
        this.type = 4;
        this.activityType = 4;
        this.overMsg = '确定结束讨论？'
      }
    }
  },
  components:{modal}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import 'screenIndex.scss'
</style>



// WEBPACK FOOTER //
// src/components/screenIndex/screenIndex.vue